import { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Markdown from '~/components/Markdown';
import YouTubePlayer from '~/components/YouTubePlayer';

import markdownStyles from './MarkdownContent.module.scss';

class ContentView extends Component {
  static propTypes = {
    className: PropTypes.string,
    contentType: PropTypes.string.isRequired,
    startAt: PropTypes.number,
    text: PropTypes.string,
    uri: PropTypes.string,
    videoId: PropTypes.string,
  };

  static defaultProps = {
    text: null,
    uri: null,
  };

  renderPlainText() {
    const { text } = this.props;
    return <p>{text}</p>;
  }

  renderMarkdown() {
    const { text } = this.props;
    return (
      <Markdown
        className={classNames(
          this.props.className,
          'markdown-content',
          markdownStyles.markdown,
        )}
        skipHtml
      >
        {text}
      </Markdown>
    );
  }

  renderLink() {
    const { text, uri } = this.props;
    return this.renderMarkdown(`[${text}](${uri})`);
  }

  renderYouTube() {
    const { videoId, startAt } = this.props;

    if (videoId) {
      return (
        <YouTubePlayer
          videoId={videoId}
          startAt={startAt}
        />
      );
    }

    // Just don't render it
    return null;
  }

  render() {
    const { contentType } = this.props;

    if (contentType === 'text/plain') {
      return this.renderPlainText();
    }
    if (contentType === 'text/markdown') {
      return this.renderMarkdown();
    }
    if (contentType === 'link') {
      return this.renderLink();
    }
    if (contentType === 'youtube') {
      return this.renderYouTube();
    }

    // Just dont render it
    return null;
  }
}

export default ContentView;
